import { render, staticRenderFns } from "./MenuPacjent.vue?vue&type=template&id=0c4ada40&scoped=true&"
import script from "./MenuPacjent.vue?vue&type=script&lang=js&"
export * from "./MenuPacjent.vue?vue&type=script&lang=js&"
import style0 from "./MenuPacjent.vue?vue&type=style&index=0&id=0c4ada40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4ada40",
  null
  
)

export default component.exports